module.exports = __webpack_public_path__ + "media/images/banners/bg3-c903985654cee919eeecca70e7f31a45.png";